import { Box, Container, Grid, Typography, Link, Stack, IconButton, useTheme } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn, YouTube } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const theme = useTheme();
  
  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Careers', path: '/careers' },
      { name: 'News', path: '/news' },
      { name: 'Contact Us', path: '/contact' },
    ],
    properties: [
      { name: 'Buy', path: '/listings?type=buy' },
      { name: 'Rent', path: '/listings?type=rent' },
      { name: 'Sell', path: '/listings?type=sell' },
      { name: 'New Developments', path: '/new-developments' },
    ],
    resources: [
      { name: 'Help Center', path: '/help' },
      { name: 'Mortgage Calculator', path: '/mortgage-calculator' },
      { name: 'Real Estate Guides', path: '/guides' },
      { name: 'Market Trends', path: '/market-trends' },
    ],
    legal: [
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Accessibility', path: '/accessibility' },
      { name: 'Cookie Policy', path: '/cookies' },
    ],
  };

  const socialLinks = [
    { icon: <Facebook />, name: 'Facebook', url: 'https://facebook.com' },
    { icon: <Twitter />, name: 'Twitter', url: 'https://twitter.com' },
    { icon: <Instagram />, name: 'Instagram', url: 'https://instagram.com' },
    { icon: <LinkedIn />, name: 'LinkedIn', url: 'https://linkedin.com' },
    { icon: <YouTube />, name: 'YouTube', url: 'https://youtube.com' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        bgcolor: theme.palette.mode === 'light' ? 'grey.100' : 'grey.900',
        color: theme.palette.text.secondary,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              DwellHub
            </Typography>
            <Typography variant="body2" paragraph>
              Find your perfect home with DwellHub. Whether you're buying, selling, or renting, we provide the tools and expertise to help you make informed decisions.
            </Typography>
            <Stack direction="row" spacing={1}>
              {socialLinks.map((social) => (
                <IconButton
                  key={social.name}
                  component="a"
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  size="small"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>

          {/* Footer Links */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom fontWeight={600}>
              Company
            </Typography>
            <Stack spacing={1.5}>
              {footerLinks.company.map((link) => (
                <Link
                  key={link.name}
                  component={RouterLink}
                  to={link.path}
                  variant="body2"
                  color="inherit"
                  underline="hover"
                >
                  {link.name}
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom fontWeight={600}>
              Properties
            </Typography>
            <Stack spacing={1.5}>
              {footerLinks.properties.map((link) => (
                <Link
                  key={link.name}
                  component={RouterLink}
                  to={link.path}
                  variant="body2"
                  color="inherit"
                  underline="hover"
                >
                  {link.name}
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom fontWeight={600}>
              Resources
            </Typography>
            <Stack spacing={1.5}>
              {footerLinks.resources.map((link) => (
                <Link
                  key={link.name}
                  component={RouterLink}
                  to={link.path}
                  variant="body2"
                  color="inherit"
                  underline="hover"
                >
                  {link.name}
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom fontWeight={600}>
              Legal
            </Typography>
            <Stack spacing={1.5}>
              {footerLinks.legal.map((link) => (
                <Link
                  key={link.name}
                  component={RouterLink}
                  to={link.path}
                  variant="body2"
                  color="inherit"
                  underline="hover"
                >
                  {link.name}
                </Link>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: `1px solid ${theme.palette.divider}`,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} DwellHub. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;